import Vue from 'vue';
import Vuex from 'vuex';
import createMutationsSharer from "vuex-shared-mutations";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createMutationsSharer({predicate: [
        'globalReload', // mutation name
      ]}),
    // createPersistedState()
  ],
  state: {

  },
  mutations: {

  },
  actions: {

  },
})
